"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketExceptions = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _ContentRoot = require("../ContentRoot");
var _styles = require("./components/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const LazyTurkishMarketException = /*#__PURE__*/_react.default.lazy(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./components/TurkishMarketException'))).then(module => ({
  default: module.TurkishMarketException
})));
const MarketExceptions = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    turkishException
  } = (0, _hooks.useFooter)();
  return turkishException ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentRoot.ContentRoot, {
    testId: getTestId(_constants.MARKET_EXCEPTIONS),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QRCodeSkeleton, {
        "data-testid": getTestId(_constants.QR_SKELETON)
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyTurkishMarketException, {})
    })
  }) : null;
};
exports.MarketExceptions = MarketExceptions;